(function () {
  'use strict';

  const roots = document.querySelectorAll('[data-bikiniyes-create-look]');
  roots.forEach(initCreateLook);

  function initCreateLook(root) {
    if (root.dataset.lookReady === 'true') return;
    root.dataset.lookReady = 'true';

    const configNode = root.querySelector('[data-look-config]');
    if (!configNode) return;

    let config;
    try { config = JSON.parse(configNode.textContent); } catch (error) { return; }

    const els = {
      catalog: root.querySelector('[data-look-catalog]'),
      search: root.querySelector('[data-look-search]'),
      tabs: Array.from(root.querySelectorAll('[data-look-tab]')),
      slots: root.querySelector('[data-look-slots]'),
      selectionCount: root.querySelector('[data-look-selection-count]'),
      add: root.querySelector('[data-look-add]'),
      model: root.querySelector('[data-look-model]'),
      modelFrame: root.querySelector('[data-look-model-frame]'),
      stageLabel: root.querySelector('[data-look-stage-label]'),
      message: root.querySelector('[data-look-message]')
    };

    const pairing = window.BikiniYesOutfitPairing;
    if (!pairing) return;
    const categoryKeys = ['tops', 'bottoms', 'onePieces', 'layers'];
    const state = {
      activeCategory: 'tops',
      products: { tops: [], bottoms: [], onePieces: [], layers: [] },
      selected: { tops: null, bottoms: null, onePieces: null, layers: null },
      query: '',
      generatedImage: '',
      positions: { tops: 64, bottoms: 72, onePieces: 35 },
      busy: false
    };

    const overlayLayer = document.createElement('div');
    overlayLayer.className = 'by-look__overlays';
    overlayLayer.setAttribute('aria-hidden', 'true');
    els.modelFrame.appendChild(overlayLayer);

    els.tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        state.activeCategory = tab.dataset.lookTab;
        els.tabs.forEach((item) => {
          const active = item === tab;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', String(active));
        });
        renderCatalog();
      });
    });

    els.search.addEventListener('input', () => {
      state.query = els.search.value.trim().toLowerCase();
      renderCatalog();
    });

    els.add.addEventListener('click', addCompleteLook);

    loadCatalog();

    async function loadCatalog() {
      try {
        let page = 1;
        let keepLoading = true;
        const products = [];
        while (keepLoading && page <= Number(config.maxPages || 4)) {
          const separator = config.catalogUrl.includes('?') ? '&' : '?';
          const response = await fetch(`${config.catalogUrl}${separator}limit=250&page=${page}`, { credentials: 'same-origin' });
          if (!response.ok) throw new Error('Catalog request failed');
          const payload = await response.json();
          const batch = Array.isArray(payload.products) ? payload.products : [];
          products.push(...batch);
          keepLoading = batch.length === 250;
          page += 1;
        }

        products.map(normalizeProduct).filter(Boolean).forEach((product) => {
          const category = classifyProduct(product);
          if (category) state.products[category].push(product);
        });

        categoryKeys.forEach((key) => {
          state.products[key].sort((a, b) => a.title.localeCompare(b.title));
          const count = root.querySelector(`[data-look-count="${key}"]`);
          if (count) count.textContent = `(${state.products[key].length})`;
        });
        preselectRequestedProduct();
        renderCatalog();
        renderSlots();
      } catch (error) {
        els.catalog.innerHTML = `<div class="by-look__empty">${escapeHtml(config.strings.loadError)}</div>`;
      }
    }

    function preselectRequestedProduct() {
      const handle = new URLSearchParams(window.location.search).get('product');
      if (!handle) return;
      for (const category of categoryKeys) {
        const product = state.products[category].find((item) => item.handle === handle);
        if (!product) continue;
        state.activeCategory = category;
        els.tabs.forEach((tab) => {
          const active = tab.dataset.lookTab === category;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
        });
        selectProduct(category, product.id);
        break;
      }
    }

    function normalizeProduct(product) {
      const variants = (product.variants || []).map((variant) => ({
        id: Number(variant.id),
        title: variant.title || '',
        available: variant.available !== false,
        price: Number(variant.price || 0)
      }));
      if (!variants.some((variant) => variant.available)) return null;

      const image = (product.images && product.images[0] && (product.images[0].src || product.images[0])) || (product.image && product.image.src) || '';
      return {
        id: product.id,
        handle: product.handle,
        title: product.title || '',
        type: product.product_type || '',
        tags: Array.isArray(product.tags) ? product.tags.join(' ') : (product.tags || ''),
        image,
        variants,
        cardColors: window.BikiniYesCardColors?.values(product) || [],
        cardSizes: window.BikiniYesCardColors?.sizes(product) || [],
        price: Math.min(...variants.filter((variant) => variant.available).map((variant) => variant.price)),
        url: `${config.productUrlBase}${product.handle}`
      };
    }

    function classifyProduct(product) {
      return pairing.slot(product);
    }

    function fitsSelection(product, category) {
      return categoryKeys.every(key => {
        if (key === category || !state.selected[key]) return true;
        if (category === 'onePieces' && (key === 'tops' || key === 'bottoms')) return true;
        if ((category === 'tops' || category === 'bottoms') && key === 'onePieces') return true;
        return pairing.compatible(product, state.selected[key].product);
      });
    }

    function renderCatalog() {
      const items = state.products[state.activeCategory].filter((product) => {
        if (!fitsSelection(product, state.activeCategory)) return false;
        if (!state.query) return true;
        return `${product.title} ${product.type} ${product.tags}`.toLowerCase().includes(state.query);
      });

      if (!items.length) {
        els.catalog.innerHTML = `<div class="by-look__empty">${escapeHtml(config.strings.empty)}</div>`;
        return;
      }

      els.catalog.innerHTML = `<div class="by-look__grid">${items.map((product) => productCard(product, state.activeCategory)).join('')}</div>`;
      els.catalog.querySelectorAll('[data-look-product]').forEach((button) => {
        button.addEventListener('click', () => selectProduct(state.activeCategory, button.dataset.lookProduct));
      });
    }

    function productCard(product, category) {
      const isSelected = state.selected[category] && String(state.selected[category].product.id) === String(product.id);
      return `
        <button class="by-look__card${isSelected ? ' is-selected' : ''}" type="button" data-look-product="${escapeHtml(String(product.id))}" aria-pressed="${isSelected}">
          <span class="by-look__card-media">${product.image ? `<img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.title)}" loading="lazy">` : ''}</span>
          <span class="by-look__card-copy">
            <span class="by-look__card-title">${escapeHtml(product.title)}</span>
            ${window.BikiniYesCardColors?.html(product.cardColors, product.cardSizes) || ''}
            <span class="by-look__card-price">${escapeHtml(formatMoney(product.price))}</span>
          </span>
          <span class="by-look__card-check" aria-hidden="true">✓</span>
        </button>`;
    }

    function selectProduct(category, productId) {
      const product = state.products[category].find((item) => String(item.id) === String(productId));
      if (!product || !fitsSelection(product, category)) return;
      const variant = product.variants.find((item) => item.available);

      if (category === 'onePieces') {
        state.selected.tops = null;
        state.selected.bottoms = null;
      } else if (category === 'tops' || category === 'bottoms') {
        state.selected.onePieces = null;
      }

      state.selected[category] = { product, variantId: variant.id };
      if (category === 'tops') state.positions.tops = 64;
      if (category === 'bottoms') state.positions.bottoms = 72;
      if (category === 'onePieces') state.positions.onePieces = 35;
      updateOverlays();
      renderCatalog();
      renderSlots();
      setMessage(`${product.title} — ${config.strings.selected}`);
    }

    function renderSlots() {
      const visibleKeys = ['tops', 'bottoms', 'onePieces', 'layers'];
      els.slots.innerHTML = visibleKeys.map((key) => slotMarkup(key)).join('');

      els.slots.querySelectorAll('[data-look-remove]').forEach((button) => {
        button.addEventListener('click', () => {
          const key = button.dataset.lookRemove;
          state.selected[key] = null;
          updateOverlays();
          renderCatalog();
          renderSlots();
        });
      });

      els.slots.querySelectorAll('[data-look-variant]').forEach((select) => {
        select.addEventListener('change', () => {
          state.selected[select.dataset.lookVariant].variantId = Number(select.value);
          updateOverlays();
        });
      });

      const count = selectedEntries().length;
      els.selectionCount.textContent = String(count);
      els.add.disabled = count === 0 || state.busy;
    }

    function slotMarkup(key) {
      const selection = state.selected[key];
      const label = config.strings.slotLabels[key];
      if (!selection) return `<div class="by-look__slot is-empty">+ ${escapeHtml(label)}</div>`;
      const product = selection.product;
      const options = product.variants.filter((variant) => variant.available).map((variant) =>
        `<option value="${variant.id}"${variant.id === selection.variantId ? ' selected' : ''}>${escapeHtml(variant.title)} — ${escapeHtml(formatMoney(variant.price))}</option>`
      ).join('');
      return `
        <div class="by-look__slot">
          ${product.image ? `<img class="by-look__slot-image" src="${escapeHtml(product.image)}" alt="" loading="lazy">` : '<span></span>'}
          <div>
            <span class="by-look__slot-label">${escapeHtml(label)}</span>
            <span class="by-look__slot-title">${escapeHtml(product.title)}</span>
            <label>
              <span class="visually-hidden">${escapeHtml(config.strings.variant)}</span>
              <select class="by-look__variant" data-look-variant="${key}">${options}</select>
            </label>
          </div>
          <button class="by-look__remove" type="button" data-look-remove="${key}" aria-label="${escapeHtml(config.strings.remove)} ${escapeHtml(product.title)}">×</button>
        </div>`;
    }

    function selectedEntries() {
      return categoryKeys.filter((key) => state.selected[key]).map((key) => ({ category: key, ...state.selected[key] }));
    }

    async function addCompleteLook() {
      const selections = selectedEntries();
      if (!selections.length) { setMessage(config.strings.noSelection); return; }
      setBusy(true);
      els.add.textContent = config.strings.adding;
      try {
        const items = selections.map((selection) => ({
          id: selection.variantId,
          quantity: 1,
          properties: { '_Styled with': 'BikiniYes Create a Look', '_Look category': selection.category }
        }));
        const response = await fetch(`${config.rootUrl}cart/add.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error('Cart request failed');
        setMessage(config.strings.added);
        els.add.textContent = config.strings.added;
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        window.setTimeout(() => { window.location.href = config.cartUrl; }, 700);
      } catch (error) {
        setMessage(config.strings.cartError);
        els.add.textContent = config.strings.addLook;
        setBusy(false);
      }
    }

    function updateOverlays() {
      const onePiece = state.selected.onePieces;
      const top = state.selected.tops;
      const bottom = state.selected.bottoms;
      const layer = state.selected.layers;
      const pieces = [];

      if (onePiece && onePiece.product.image) {
        pieces.push(`<img class="by-look__outfit-image by-look__outfit-image--full" data-look-adjust="onePieces" draggable="false" style="object-position:center ${state.positions.onePieces}%" src="${escapeHtml(onePiece.product.image)}" alt="">`);
      } else {
        if (top && top.product.image) pieces.push(`<img class="by-look__outfit-image by-look__outfit-image--top" data-look-adjust="tops" draggable="false" style="object-position:center ${state.positions.tops}%" src="${escapeHtml(top.product.image)}" alt="">`);
        if (bottom && bottom.product.image) pieces.push(`<img class="by-look__outfit-image by-look__outfit-image--bottom" data-look-adjust="bottoms" draggable="false" style="object-position:center ${state.positions.bottoms}%" src="${escapeHtml(bottom.product.image)}" alt="">`);
      }

      if (layer && layer.product.image) {
        pieces.push(`<span class="by-look__layer-card"><img src="${escapeHtml(layer.product.image)}" alt=""></span>`);
      }

      if (pieces.length) {
        pieces.push(`<span class="by-look__drag-hint"><b aria-hidden="true">↕</b>${escapeHtml(config.strings.dragHint)}</span>`);
      }

      overlayLayer.innerHTML = pieces.join('');
      bindImagePositioning();
      const count = selectedEntries().length;
      els.model.classList.toggle('has-look', count > 0);
      overlayLayer.classList.toggle('has-look', count > 0);
      els.stageLabel.textContent = count > 0 ? config.strings.selectedPreview : config.strings.basePreview;
    }

    function bindImagePositioning() {
      overlayLayer.querySelectorAll('[data-look-adjust]').forEach((image) => {
        image.addEventListener('pointerdown', (event) => {
          event.preventDefault();
          const key = image.dataset.lookAdjust;
          const startY = event.clientY;
          const startPosition = state.positions[key];
          image.setPointerCapture(event.pointerId);
          image.classList.add('is-adjusting');

          const move = (moveEvent) => {
            const frameHeight = image.getBoundingClientRect().height || 1;
            const change = ((moveEvent.clientY - startY) / frameHeight) * 70;
            const next = Math.max(0, Math.min(100, startPosition - change));
            state.positions[key] = next;
            image.style.objectPosition = `center ${next}%`;
          };

          const stop = () => {
            image.classList.remove('is-adjusting');
            image.removeEventListener('pointermove', move);
            image.removeEventListener('pointerup', stop);
            image.removeEventListener('pointercancel', stop);
          };

          image.addEventListener('pointermove', move);
          image.addEventListener('pointerup', stop);
          image.addEventListener('pointercancel', stop);
        });
      });
    }

    function setBusy(busy) {
      state.busy = busy;
      els.add.disabled = busy || selectedEntries().length === 0;
    }

    function setMessage(message) { els.message.textContent = message || ''; }

    function formatMoney(value) {
      try {
        return new Intl.NumberFormat(config.locale || 'en', { style: 'currency', currency: config.currency }).format(Number(value));
      } catch (error) {
        return `${Number(value).toFixed(2)} ${config.currency}`;
      }
    }

    function escapeHtml(value) {
      return String(value == null ? '' : value).replace(/[&<>'"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character]));
    }
  }
})();

